import * as React from 'react'
import { MuiThemeProvider, createMuiTheme, Theme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

function withRoot(Component: any) {
  function WithRoot(props: any) {
    // MuiThemeProvider makes the theme available down the React tree thanks to React context.
    const theme: Theme = createMuiTheme({
      palette: {
        primary: {
          // ligth: '#69696a',
          // main: '#28282a',
          main: "#37474f",
          dark: "#1e1e1f"
        },
        secondary: {
          light: "#fff5f8",
          main: "#ff3366",
          dark: "#e62958"
        }
      },

      typography: {
        fontFamily: "'Work Sans', sans-serif",
        fontSize: 14,
        fontWeightLight: 300, // Work Sans
        fontWeightRegular: 400, // Work Sans
        fontWeightMedium: 700, // Roboto Condensed
        // fontFamilySecondary: "'Roboto Condensed', sans-serif",
        useNextVariants: true
      },
      overrides: {
        MuiButton: {
          root: {
            margin: "10px",
            padding: "10px"
          }
        }
      }
    });
    
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  }

  return WithRoot;
}
export default withRoot;


// WEBPACK FOOTER //
// ./src/withRoot.tsx